import { UnderWritungUser } from "../dashboard/dashboard.constants";
import Notfound from "../notfound";

const HideFromUW = ({ children }) => {
    const userType = sessionStorage?.userType ?? '';


    return userType !== UnderWritungUser ? ( children ) : <Notfound></Notfound>
}

export default HideFromUW;